var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6777 16.5645C32.6777 25.4632 25.4632 32.6777 16.5645 32.6777C7.6656 32.6777 0.451172 25.4632 0.451172 16.5645C0.451172 7.6656 7.6656 0.451172 16.5645 0.451172C25.4632 0.451172 32.6777 7.6656 32.6777 16.5645Z",
    fill: "#3C5A99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6153 17.1958H17.7402V27.7285H13.3842V17.1958H11.3125V13.493H13.3842V11.0979C13.3842 9.38527 14.1975 6.70215 17.7794 6.70215L21.0052 6.71613V10.3095H18.6644C18.2801 10.3095 17.7402 10.5015 17.7402 11.318V13.4974H20.9968L20.6153 17.1958Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon-fb.50d699776425aa516179847dc5b53a8e.svg";
export { ForwardRef as ReactComponent };